/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var React = require('react');
var Router = require('react-router');
var $__0=    require('../../../../'),Seq=$__0.Seq;
var $__1=     require('./Defs'),InterfaceDef=$__1.InterfaceDef,CallSigDef=$__1.CallSigDef;
var MemberDoc = require('./MemberDoc');
var isMobile = require('./isMobile');
var SideBar = require('./SideBar');
var MarkDown = require('./MarkDown');
var DocOverview = require('./DocOverview');
var collectMemberGroups = require('../../../lib/collectMemberGroups');
var TypeKind = require('../../../lib/TypeKind');
var defs = require('../../../lib/getTypeDefs');

var typeDefURL =
  'https://github.com/facebook/immutable-js/blob/master/type-definitions/Immutable.d.ts';
var issuesURL = 'https://github.com/facebook/immutable-js/issues';

var Disclaimer = function() {
  return (
    React.createElement("section", {className: "disclaimer"}, 
      "This documentation is generated from", ' ', 
      React.createElement("a", {href: typeDefURL}, "Immutable.d.ts"), ". Pull requests and", ' ', 
      React.createElement("a", {href: issuesURL}, "Issues"), " welcome."
    )
  );
};

var TypeDocumentation = React.createClass({displayName: "TypeDocumentation",
  getInitialState:function() {
    return {
      showInherited: true,
      showInGroups: true,
    };
  },

  toggleShowInGroups:function() {
    this.setState({ showInGroups: !this.state.showInGroups });
  },

  toggleShowInherited:function() {
    this.setState({ showInherited: !this.state.showInherited });
  },

  render:function() {
    var name = this.props.name;
    var memberName = this.props.memberName;
    var def = this.props.def;

    var memberGroups = collectMemberGroups(def && def.interface, {
      showInGroups: this.state.showInGroups,
      showInherited: this.state.showInherited,
    });

    return (
      React.createElement("div", null, 
        isMobile || (
          React.createElement(SideBar, {
            focus: name, 
            memberGroups: memberGroups, 
            toggleShowInherited: this.toggleShowInherited, 
            toggleShowInGroups: this.toggleShowInGroups, 
            showInGroups: this.state.showInGroups, 
            showInherited: this.state.showInherited}
          )
        ), 
        React.createElement("div", {key: name, className: "docContents"}, 
          !def ? (
            React.createElement(NotFound, null)
          ) : !name ? (
            React.createElement(DocOverview, {def: def})
          ) : !def.interface && !def.module ? (
            React.createElement(FunctionDoc, {name: name, def: def.call})
          ) : (
            React.createElement(TypeDoc, {
              name: name, 
              def: def, 
              memberName: memberName, 
              memberGroups: memberGroups}
            )
          )
        )
      )
    );
  },
});

function NotFound() {
  return React.createElement("div", null, "Not found");
}

var FunctionDoc = React.createClass({displayName: "FunctionDoc",
  render:function() {
    var name = this.props.name;
    var def = this.props.def;
    var doc = def.doc || {};

    return (
      React.createElement("div", null, 
        React.createElement("h1", {className: "typeHeader"}, name + '()'), 
        doc.synopsis && (
          React.createElement(MarkDown, {className: "synopsis", contents: doc.synopsis})
        ), 
        React.createElement("code", {className: "codeBlock memberSignature"}, 
          def.signatures.map(function(callSig, i)  {return [
            React.createElement(CallSigDef, {key: i, name: name, callSig: callSig}),
            '\n',
          ];})
        ), 
        doc.notes &&
          doc.notes.map(function(note, i)  
            {return React.createElement("section", {key: i}, 
              React.createElement("h4", {className: "infoHeader"}, note.name), 
              note.name === 'alias' ? (
                React.createElement(CallSigDef, {name: note.body})
              ) : (
                note.body
              )
            );}
          ), 
        doc.description && (
          React.createElement("section", null, 
            React.createElement("h4", {className: "infoHeader"}, 
              doc.description.substr(0, 5) === '<code'
                ? 'Example'
                : 'Discussion'
            ), 
            React.createElement(MarkDown, {className: "discussion", contents: doc.description})
          )
        ), 
        React.createElement(Disclaimer, null)
      )
    );
  },
});

var TypeDoc = React.createClass({displayName: "TypeDoc",
  render:function() {
    var name = this.props.name;
    var def = this.props.def;
    var memberName = this.props.memberName;
    var memberGroups = this.props.memberGroups;

    var doc = def.doc || {};
    var call = def.call;
    var functions = Seq(def.module).filter(function(t)  {return !t.interface && !t.module;});
    var types = Seq(def.module).filter(function(t)  {return t.interface || t.module;});
    var interfaceDef = def.interface;
    var typePropMap = getTypePropMap(interfaceDef);

    return (
      React.createElement("div", null, 
        React.createElement("h1", {className: "typeHeader"}, name), 
        doc.synopsis && (
          React.createElement(MarkDown, {className: "synopsis", contents: doc.synopsis})
        ), 
        interfaceDef && (
          React.createElement("code", {className: "codeBlock memberSignature"}, 
            React.createElement(InterfaceDef, {name: name, def: interfaceDef})
          )
        ), 

        doc.notes &&
          doc.notes.map(function(note, i)  
            {return React.createElement("section", {key: i}, 
              React.createElement("h4", {className: "infoHeader"}, note.name), 
              note.name === 'alias' ? (
                React.createElement(CallSigDef, {name: note.body})
              ) : (
                note.body
              )
            );}
          ), 

        doc.description && (
          React.createElement("section", null, 
            React.createElement("h4", {className: "infoHeader"}, 
              doc.description.substr(0, 5) === '<code'
                ? 'Example'
                : 'Discussion'
            ), 
            React.createElement(MarkDown, {className: "discussion", contents: doc.description})
          )
        ), 

        types.count() > 0 && (
          React.createElement("section", null, 
            React.createElement("h4", {className: "groupTitle"}, "Sub-types"), 
            types
              .map(function(t, typeName)  
                {return React.createElement("div", {key: typeName}, 
                  React.createElement(Router.Link, {
                    to: '/' + (name ? name + '.' + typeName : typeName)
                  }, 
                    name ? name + '.' + typeName : typeName
                  )
                );}
              )
              .valueSeq()
              .toArray()
          )
        ), 

        call && (
          React.createElement("section", null, 
            React.createElement("h4", {className: "groupTitle"}, "Construction"), 
            React.createElement(MemberDoc, {
              showDetail: name === memberName, 
              parentName: name, 
              member: {
                memberName: name,
                memberDef: call,
              }}
            )
          )
        ), 

        functions.count() > 0 && (
          React.createElement("section", null, 
            React.createElement("h4", {className: "groupTitle"}, "Static methods"), 
            functions
              .map(function(t, fnName)  
                {return React.createElement(MemberDoc, {
                  key: fnName, 
                  showDetail: fnName === memberName, 
                  parentName: name, 
                  member: {
                    memberName: fnName,
                    memberDef: t.call,
                    isStatic: true,
                  }}
                );}
              )
              .valueSeq()
              .toArray()
          )
        ), 

        React.createElement("section", null, 
          Seq(memberGroups)
            .map(
              function(members, title) 
                {return members.length === 0
                  ? null
                  : Seq([
                      React.createElement("h4", {key: title || 'Members', className: "groupTitle"}, 
                        title || 'Members'
                      ),
                      Seq(members).map(function(member)  
                        {return React.createElement(MemberDoc, {
                          typePropMap: typePropMap, 
                          key: member.memberName, 
                          showDetail: member.memberName === memberName, 
                          parentName: name, 
                          member: member}
                        );}
                      ),
                    ]);}
            )
            .flatten()
            .valueSeq()
            .toArray()
        ), 

        React.createElement(Disclaimer, null)
      )
    );
  },
});

/**
 * Get a map from super type parameter to concrete type definition. This is
 * used when rendering inherited type definitions to ensure contextually
 * relevant information.
 *
 * Example:
 *
 *   type A<T> implements B<number, T>
 *   type B<K, V> implements C<K, V, V>
 *   type C<X, Y, Z>
 *
 * parse C:
 *   {}
 *
 * parse B:
 *   { C<X: K
 *     C<Y: V
 *     C<Z: V }
 *
 * parse A:
 *   { B<K: number
 *     B<V: T
 *     C<X: number
 *     C<Y: T
 *     C<Z: T }
 */
function getTypePropMap(def) {
  var map = {};
  def &&
    def.extends &&
    def.extends.forEach(function(e)  {
      var superModule = defs.Immutable;
      e.name.split('.').forEach(function(part)  {
        superModule =
          superModule && superModule.module && superModule.module[part];
      });
      var superInterface = superModule && superModule.interface;
      if (superInterface) {
        var interfaceMap = Seq(superInterface.typeParams)
          .toKeyedSeq()
          .flip()
          .map(function(i)  {return e.args[i];})
          .toObject();
        Seq(interfaceMap).forEach(function(v, k)  {
          map[e.name + '<' + k] = v;
        });
        var superMap = getTypePropMap(superInterface);
        Seq(superMap).forEach(function(v, k)  {
          map[k] = v.k === TypeKind.Param ? interfaceMap[v.param] : v;
        });
      }
    });
  return map;
}

module.exports = TypeDocumentation;
